import { AdjustmentDeliveryNoteModelType } from '@teinor/erp/types/company/order/adjustmentDeliveryNote'
import ITHeaderText from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import InputTableLeftColumnForm from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/InputTableLeftColumnForm'
import { InputTableLeftTabsProps } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { OrderHeaderURLs } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { parseAddressToOneLine } from '../../../../../../../../utils/globals/address'
import { displayDate } from '../../../../../../../../utils/globals/date'
import { returnClassOfSpanTemplate } from '../../../../../../../../utils/globals/tailwind'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getActiveCurrenciesDictionary } from '../../../../../../../../utils/reducers/getters'

type AdjustmentStepHeaderMainNoPermissionProps = InputTableLeftTabsProps & {
    orderHeaderURLs: OrderHeaderURLs
}

const AdjustmentStepHeaderMainNoPermission: React.FC<AdjustmentStepHeaderMainNoPermissionProps> = ({ handleChange, headerData }) => {
    const { t } = useTwinTranslation()
    const activeCurrencies = getActiveCurrenciesDictionary()
    const sections: FormRender<AdjustmentDeliveryNoteModelType> = [
        {
            cols: 5,
            elements: [
                {
                    name: 'RepresentativeEmployeeId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('representative', 'Representante')} value={headerData?.RepresentativeEmployee?.fullname_short} className={returnClassOfSpanTemplate(5)} />
                },
                {
                    name: 'processed_date',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('dateAdjustmentOrder', 'Fecha de la compra')} value={displayDate(new Date(value))} className={returnClassOfSpanTemplate(3)} />
                },
                {
                    name: 'full_assigned_number',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('assignedNumber', 'Nº asignado')} value={value} className={(headerData?.assigned_number ? '' : 'text-red-BA') + ' ' + returnClassOfSpanTemplate(2)} />,
                },
                {
                    name: 'BillingWorkingCenterId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('billedBy', 'Facturado por')} value={headerData?.BillingWorkingCenter?.name || ''} className={returnClassOfSpanTemplate(3)} />
                },
                {
                    name: 'WorkingCenterCounterId',
                    component: 'Custom',
                    render: () => {
                        return <ITHeaderText label={t('serie', 'Serie')} value={headerData?.WorkingCenterCounter?.serie} className={returnClassOfSpanTemplate(2)} />
                    }
                },
                {
                    name: 'WorkingCenterId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('adjustmentedBy', 'Comprado por')} value={headerData.WorkingCenter.name || ''} className={returnClassOfSpanTemplate(3)} />
                },
                {
                    name: 'BillingAddressId',
                    component: 'Custom',
                    render: () => {
                        return <ITHeaderText label={t('workingCenterAddress', 'Dirección centro de trabajo')} value={parseAddressToOneLine(headerData?.BillingWorkingCenter)
                        } className={returnClassOfSpanTemplate(5)} />
                    },
                },
                {
                    name: 'CurrencyId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('currency', 'Moneda')} value={activeCurrencies?.[value]?.name} className={returnClassOfSpanTemplate(5)} />
                },
            ]
        }
    ]
    return (
        <InputTableLeftColumnForm form={sections} handleChange={handleChange} headerData={headerData} />
    )
}


export default AdjustmentStepHeaderMainNoPermission